export default "__VITE_ASSET__DsEFGykP__"